import { Deserializable } from './deserializable.model';
import { JsonObject } from './json-object.model';

export enum Setting {
  autoAdvance = 'autoAdvance',
  darkMode = 'darkMode',
  staySignedIn = 'staySignedIn',
}

export class Settings implements Deserializable<JsonObject, Settings> {
  constructor(public autoAdvance?: boolean, public darkMode?: boolean, public staySignedIn?: boolean) {}

  deserialize(input: JsonObject): Settings {
    if (input == null) {
      return null;
    }
    this.autoAdvance = input['autoAdvance'];
    this.darkMode = input['darkMode'];
    this.staySignedIn = input['staySignedIn'];

    return this;
  }
}
